import { Checkbox as ChakraCheckbox } from '@chakra-ui/react'
import tailwind from '../../../tailwind.config'
import * as React from 'react'

export const Checkbox = React.forwardRef(function Checkbox(props, ref) {
  const grey = tailwind.theme.colors["grey"]
  const { icon, children, inputProps, rootRef, ...rest } = props

  return (
    <ChakraCheckbox.Root
      ref={rootRef}
      _hover={{ cursor: "pointer" }}
      {...rest}
    >
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control
        borderColor={grey}
        borderWidth={2}
        borderRadius={'md'}
      >
        {icon || <ChakraCheckbox.Indicator />}
      </ChakraCheckbox.Control>
      {children != null && (
        <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>
      )}
    </ChakraCheckbox.Root>
  )
})
